module.exports = __webpack_public_path__ + "img/logo_retix.b106fb50.svg";